<template>
  <v-main>
    <router-view></router-view>
  </v-main>
</template>

<script>
export default {
  name: 'emptyLayout',
}
</script>

<style scoped></style>
